var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"offer-wrapper",attrs:{"id":"learn_more"}},[_c('div',{staticClass:"container"},_vm._l((_vm.manufacturers),function(manufacturer){return _c('div',{key:manufacturer.abbr,staticClass:"col-md-3 manufacturer-summary"},[_c('ManufacturerListCard',_vm._b({},'ManufacturerListCard',manufacturer,false))],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }